// extracted by mini-css-extract-plugin
module.exports = {"all_component":"BeDonor_all_component__1LV2b","donor_form":"BeDonor_donor_form__Mon8r","donor_form2":"BeDonor_donor_form2__2yE_c"};